import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'
import {ChangeLogViewerProps} from "./types";
import {ICONS} from "../common";
import {RestService} from "../../services";
import Moment from "react-moment";


export const ChangeLogViewer = ({
  url
}:ChangeLogViewerProps) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  const [changeLog, setChangeLog] = useState([])

  return (
    <>

        <ReactBootstrap.Button
          variant={"dark"}
          size={"sm"}
          onClick={(e) => {
               e.stopPropagation();  //  <-
              setIsPaneOpen(true)
          }}
        >
            {ICONS.LOG} Change log
        </ReactBootstrap.Button>


      <SlidingPane
        overlayClassName="on-top"
        width={"50vw"}
        isOpen={isPaneOpen}
        title={"Change log"}
        onAfterOpen={() => {
            new RestService(url).get_change_log().then((response) => {
                // @ts-ignore
                setChangeLog(response)
            }).catch((error) => {
                console.log(error)
            })

        }}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >

              <ReactBootstrap.Table striped bordered hover>
                   <tbody>
                    <tr>
                          <th>Value</th>
                       <th>Changed  On</th>
                       <th>Changed By</th>

                   </tr>
                   {changeLog?.map((log, index) => {
                            return (

                                    <tr key={index}>
                                        <td>{log.value}</td>

                                        <td> <Moment format="DD-MM-YYYY hh:mm A" local>
        {log.created_at}
      </Moment></td>

                                        <td>
        {log.created_by}
      </td>

                                    </tr>

                            )
                        })}

                     </tbody>
              </ReactBootstrap.Table>


      </SlidingPane>
    </>
  )
}

ChangeLogViewer.defaultProps = {
  buttonType: 'button',
  variant: 'dark',
  size: 'sm',
}
